import React, { ForwardedRef } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { IOrder } from "../types/api";
import logo from "../assets/images/WisconsinBaseballTournaments_Full_Logo_Resize-1.png";
import "../assets/css/wibb/pages/register.scss";
import { currencyFormat, defaultDateTimeFormat } from "../lib/utils";

const OrderDetails = React.forwardRef(
    (
        {
            paymentStatus,
            order,
        }: {
            paymentStatus?: string;
            order: IOrder;
        },
        ref: ForwardedRef<HTMLDivElement>,
    ): React.JSX.Element => {
        let header = "";
        switch (paymentStatus) {
            case "succeeded":
                header = "Checkout complete!";
                break;
            case "proccessing":
                header = "Your payment is processing";
                break;
            default:
                header = "Thank you for your order";
                break;
        }

        return (
            <>
                <Container className="pt-5">
                    <Row>
                        <Col md={6}>
                            <h2>{header}</h2>
                            {order.paymentType === "Check" ? (
                                <p className="my-4">
                                    <b>Please send check payment to:</b>
                                    <br />
                                    Baseball365
                                    <br />
                                    PO Box 5614
                                    <br />
                                    Madison, WI 53705
                                    <br />
                                    <br />
                                    Checks should be made payable to Baseball365
                                    <br />
                                    Please print this page and submit with your
                                    payment
                                </p>
                            ) : (
                                <p>
                                    Feel free to print this page for your
                                    records
                                </p>
                            )}
                            <h3 className="mt-5">Order Details:</h3>
                        </Col>
                    </Row>
                </Container>
                <Container className="pt-3 pb-5 thankYou" ref={ref}>
                    <Row>
                        <Col md={6}>
                            <img
                                src={logo}
                                alt="WisonsinBaseballTournaments.com Logo"
                                className="onlyPrint mb-3"
                            />

                            <div className="space-y-3">
                                <p>
                                    <b>Order Number:</b> {order.id}
                                    <br />
                                    <b>Order Placed:</b>{" "}
                                    {defaultDateTimeFormat.format(
                                        new Date(order.date),
                                    )}
                                </p>
                                <Table className="regInfo productDetails">
                                    <tbody>
                                        <tr>
                                            <th>Registration</th>
                                            <th></th>
                                            <th>Price</th>
                                        </tr>
                                        {order.products
                                            ? order.products.map((p, idx) => (
                                                  <tr
                                                      className={
                                                          idx ===
                                                          order.products
                                                              .length -
                                                              1
                                                              ? "lastItem"
                                                              : ""
                                                      }
                                                  >
                                                      <td width="60%">
                                                          {p.description}
                                                          <dl>
                                                              <dt>
                                                                  New or
                                                                  Existing
                                                                  Team?:
                                                              </dt>
                                                              <dd>
                                                                  {
                                                                      p.meta
                                                                          .teamType
                                                                  }
                                                              </dd>
                                                              <dt>New Team</dt>
                                                              <dd>
                                                                  {
                                                                      p.meta
                                                                          .teamName
                                                                  }
                                                              </dd>
                                                          </dl>
                                                      </td>
                                                      <td width="20%"></td>
                                                      <td width="20%">
                                                          {p.orderPrice !==
                                                              p.itemPrice && (
                                                              <>
                                                                  <s>
                                                                      {currencyFormat.format(
                                                                          p.itemPrice,
                                                                      )}
                                                                  </s>
                                                                  <br />
                                                              </>
                                                          )}
                                                          {currencyFormat.format(
                                                              p.orderPrice,
                                                          )}
                                                      </td>
                                                  </tr>
                                              ))
                                            : ""}
                                        <tr className="paymentInfo">
                                            <td></td>
                                            <td>SUBTOTAL</td>
                                            <td>
                                                {currencyFormat.format(
                                                    order.total,
                                                )}
                                            </td>
                                        </tr>
                                        {order.coupon &&
                                            parseFloat(
                                                order.discount.toString(),
                                            ) !== 0 && (
                                                <>
                                                    <tr className="paymentInfo">
                                                        <td></td>
                                                        <td>COUPON CODE</td>
                                                        <td>
                                                            {order.coupon.code}
                                                        </td>
                                                    </tr>
                                                    <tr className="paymentInfo">
                                                        <td></td>
                                                        <td>DISCOUNT</td>
                                                        <td>
                                                            {currencyFormat.format(
                                                                order.discount,
                                                            )}
                                                        </td>
                                                    </tr>
                                                </>
                                            )}
                                        <tr className="paymentInfo">
                                            <td></td>
                                            <td>PAYMENT METHOD</td>
                                            <td>{order.paymentType}</td>
                                        </tr>
                                        <tr className="paymentInfo total">
                                            <td></td>
                                            <td>TOTAL</td>
                                            <td>
                                                {currencyFormat.format(
                                                    order.total -
                                                        order.discount,
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3}>
                                                <b>Billing Info</b>
                                                <ul className="customerInfo">
                                                    <li>{order.user.name}</li>
                                                    <li>{order.user.phone}</li>
                                                    <li>{order.user.email}</li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan={3}></td>
                                        </tr>
                                    </tfoot>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    },
);

export default OrderDetails;
